module.exports = __webpack_public_path__ + "img/group.e62c0311.png";